module.exports = __webpack_public_path__ + "static/media/mask_group_small.e0e63e92.png";